import ButtonComponent from "components/common/Button/ButtonComponent";
import HeadingText from "components/common/HeadingText/HeadingText";
import LoaderComponent from "components/common/Loader/Loader";
import Toaster from "components/common/Toaster/Toaster";
import {
  ACTIVE,
  INACTIVE,
  PAIYA_TOAST_MSG,
  STATUS_VALUE,
  UPLOAD_GIFT_CSV,
  UPLOAD_STORE_CSV
} from "config/constants";
import {
  PAIYA_GIFT_CSV_UPLOAD_URL,
  PAIYA_STORE_CSV_UPLOAD_URL
} from "config/Url";
import {
  IIdValuePairResponse,
  ISearchSelectChange,
  ISelectedMovRefObject
} from "interfaces/Index";
import { normalizeBulkUploadPayload } from "normalizer/GlobalProductNormalizer";
import { normalizePaiyaMovGameStatus } from "normalizer/PaiyaNormalizer";
import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Form, Row } from "reactstrap";
import PaiyaDetails from "./PaiyaDetails/PaiyaDetails";
import PaiyaError from "./PaiyaError/PaiyaError";
import { IPaiyaMOVErrorObject } from "./PaiyaMov/CustomerChannelList/CustomerChannelList.interface";
import PaiyaMov from "./PaiyaMov/PaiyaMov";
import "./PaiyaPage.scss";
import PaiyaUploads from "./PaiyaUploads/PaiyaUploads";
import { IPaiyaPageCreationProps } from "./PaiyaPage.interface";

const PaiyaPage: React.FunctionComponent<IPaiyaPageCreationProps> = (
  props: IPaiyaPageCreationProps
) => {
  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });


  const [giftCsvFileName, setGiftCSVFilename] = useState(
    props.dummyFileName || ""
  );
  const [storeCsvFileName, setStoreCSVFilename] = useState(
    props.dummyFileName || ""
  );

  const [showStatusModal, setShowStatusModal] = useState(false);

  const [city] = useState<ISearchSelectChange>();

  const [paiyaConfigCreation, setPaiyaConfigCreation] = useState<any>({
    giftCsvFile: null,
    storeCsvFile: null,
    cityId: "",
    paiyaId: "",
    giftCsvFileName: "",
    storeCsvFileName: "",
    mov: props.paiyaConfig ? props.paiyaConfig.requirement.value : "",
    status: props.paiyaConfig
      ? props.paiyaConfig.status === INACTIVE
        ? false
        : true
      : ACTIVE,
  });
  let selectedMov = useRef<ISelectedMovRefObject[]>([]);
  let [movValidationState, setMovValidationState] =
    useState<IPaiyaMOVErrorObject>({});

  useEffect(() => {
    const { paiyaConfig } = props;
    if (paiyaConfig) {
      setPaiyaConfigCreation({
        ...paiyaConfigCreation,
        status: !(paiyaConfig.status === INACTIVE),
        mov: paiyaConfig.requirement.value,
      });
    } else {
      setPaiyaConfigCreation({
        ...paiyaConfigCreation,
        status: paiyaConfigCreation.status,
        mov: "",
      });
    }
  }, [
    props.isPaiyaTypesFetched,
    props.paiyaTypesList,
    props.isPaiyaConfigFetch,
    props.paiyaConfig,
  ]);
  useEffect(() => {
    const { fetchPaiyaTypes, fetchCustomerChannelAction, fetchCities } = props;
    fetchPaiyaTypes();
    fetchCustomerChannelAction();
    fetchCities();
  }, []);

  const openStatusModal = () => {
    setShowStatusModal(true);
  }

  const closeStatusModal = () => {
    setShowStatusModal(false);
  }


  const handleSelectedCityChange = (e: IIdValuePairResponse) => {
    const { fetchPaiyaConfig } = props;
    fetchPaiyaConfig(props.paiyaTypesList[0].label, e.id);
    setPaiyaConfigCreation({
      ...paiyaConfigCreation,
      cityId: e.id,
      status: !(paiyaConfigCreation.status === INACTIVE),
      requirement: paiyaConfigCreation.requirement,
    });
  };
  const validateForm = paiyaConfigCreation.cityId;

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  const handleGiftCSVInputChange = (giftCsvFile: any) => {
    if (giftCsvFile) {
      setPaiyaConfigCreation({
        ...paiyaConfigCreation,
        giftCsvFile: giftCsvFile,
        giftCsvFileName: giftCsvFile.name,
        isGiftCsvUploaded: false,
      });
      setGiftCSVFilename(giftCsvFile.name);
    }
  };

  const handleStoreCSVInputChange = (storeCsvFile: any) => {
    if (storeCsvFile) {
      setPaiyaConfigCreation({
        ...paiyaConfigCreation,
        storeCsvFile: storeCsvFile,
        storeCsvFileName: storeCsvFile.name,
        isStoreCsvUploaded: false,
      });
      setStoreCSVFilename(storeCsvFile.name);
    }
  };

  const { isStoreCsvLoading, isGiftCsvLoading, isMovStatusLoading, isStoreCsvUploaded, isGiftCsvUploaded } = props;


  useEffect(() => {

    const isFilesUploadedToAPI = isStoreCsvUploaded || isGiftCsvUploaded;
    const hasAllApisResponded = !isStoreCsvLoading && !isGiftCsvLoading && !isMovStatusLoading;
    const isUploadStatusReady = isFilesUploadedToAPI && hasAllApisResponded;

    if (isUploadStatusReady) {
      openStatusModal();
    }
  }, [isStoreCsvLoading, isGiftCsvLoading, isMovStatusLoading, isStoreCsvUploaded, isGiftCsvUploaded])

  const handleSubmit = () => {
    const {
      createPaiyaStoreCsv,
      createPaiyaGiftCsv,
      createPaiyaMovGameStatus,
    } = props;
    let paiyaVariantType = props.paiyaTypesList[0];

    if (paiyaConfigCreation.storeCsvFileName) {
      const normalizedStoreCsvPayload = normalizeBulkUploadPayload(
        paiyaConfigCreation.storeCsvFile
      );

      createPaiyaStoreCsv(
        paiyaVariantType.label,
        paiyaConfigCreation.cityId,
        normalizedStoreCsvPayload,
        PAIYA_STORE_CSV_UPLOAD_URL
      );
    }

    if (paiyaConfigCreation.giftCsvFileName) {

      const normalizedGiftCsvPayload = normalizeBulkUploadPayload(
        paiyaConfigCreation.giftCsvFile
      );

      createPaiyaGiftCsv(
        paiyaVariantType.label,
        paiyaConfigCreation.cityId,
        normalizedGiftCsvPayload,
        PAIYA_GIFT_CSV_UPLOAD_URL
      );
    }

    const normalizedPaiyaMovGameStatusPayload = normalizePaiyaMovGameStatus(
      paiyaConfigCreation.status,
      selectedMov.current
    );

    createPaiyaMovGameStatus(
      paiyaVariantType.label,
      paiyaConfigCreation.cityId,
      normalizedPaiyaMovGameStatusPayload
    );

    setPaiyaConfigCreation({
      ...paiyaConfigCreation,
      mov: paiyaConfigCreation.mov,
      status: paiyaConfigCreation.status,
    });

  };

  const handleGiftCSVRemove = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setGiftCSVFilename("");
    paiyaConfigCreation.giftCsvFileName = UPLOAD_GIFT_CSV;
    setPaiyaConfigCreation({
      ...paiyaConfigCreation,
      isGiftCsvUploaded: false,
      isGiftCsvLoading: false,
      giftCsvFileName: "",
    });
  };

  const handleStoreCSVRemove = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setStoreCSVFilename("");
    paiyaConfigCreation.storeCsvFileName = UPLOAD_STORE_CSV;
    setPaiyaConfigCreation({
      ...paiyaConfigCreation,
      isStoreCsvUploaded: false,
      isStoreCsvLoading: false,
      storeCsvFileName: "",
    });
  };

  const handleSwitchChange = (e: any) => {
    const fieldId: string = e.target.id;
    const fieldValue: string = e.target.value;
    setPaiyaConfigCreation({
      ...paiyaConfigCreation,
      [fieldId]:
        fieldId === STATUS_VALUE ? !paiyaConfigCreation[fieldId] : fieldValue,
    });
  };

  const checkMovValidation = () => {
    const movValidationStateArray = Object.keys(movValidationState).map(
      (key) => movValidationState[key]
    );
    return movValidationStateArray.some((item) => item.error);
  };

  const isLoading = props.isStoreCsvLoading || props.isGiftCsvLoading || props.isMovStatusLoading || props.isLoading;

  const renderForm = () => {
    return (
      <Row className="form-container form-set-margin ml-0 mr-0">
        <Toaster
          showToaster={showToaster.isVisible}
          toasterClass={
            showToaster.isError
              ? "toaster toaster-bg-danger"
              : "toaster toaster-bg-success"
          }
        >
          {showToaster.message || ""}
        </Toaster>
        <Col xs="12">
          <div>
            <PaiyaDetails
              citiesList={props.citiesList}
              handleSelectedCityChange={handleSelectedCityChange}
              city={city}
              handleSwitchChange={handleSwitchChange}
              paiyaTypesList={props.paiyaTypesList}
              paiyaConfigCreation={paiyaConfigCreation}
            // handleSelectedPaiyaChange={handleSelectedPaiyaChange}
            />
          </div>
          <div className="form-row-separator">
            <PaiyaMov
              paiyaConfig={props.paiyaConfig}
              selectedMov={selectedMov}
              customerChannel={props.customerConfig?.customerChannels || []}
              movValidationState={
                movValidationState ? movValidationState : ({} as any)
              }
              setMovValidationState={setMovValidationState}
            />
          </div>
          <div className="form-row-separator">
            <PaiyaUploads
              giftCsvFileName={giftCsvFileName}
              handleGiftCSVInputChange={handleGiftCSVInputChange}
              handleGiftCSVRemove={handleGiftCSVRemove}
              handleStoreCSVInputChange={handleStoreCSVInputChange}
              handleStoreCSVRemove={handleStoreCSVRemove}
              storeCsvFileName={storeCsvFileName}
              isGiftCsvError={props.isGiftCsvError}
              isStoreCsvError={props.isStoreCsvError}
              isGiftCsvLoading={props.isGiftCsvLoading}
              isStoreCsvLoading={props.isStoreCsvLoading}
              paiyaConfigCreation={paiyaConfigCreation}
            />
          </div>
          <div className="form-row-separator">
            <ButtonComponent
              buttonClass="large-button btn-primary submit-button"
              buttonText={"Save"}
              onClickHandler={handleSubmit}
              buttonStyles={{ marginRight: "30px" }}
              isDisable={
                isLoading || !validateForm || checkMovValidation()
              }
            />
          </div>

          {isLoading && <LoaderComponent />}
        </Col>
      </Row>
    );
  };

  return (
    <Container fluid className="paiya-container mt-8">
      <Row>
        <Col lg="5">
          <div className="paiya-main-heading main-heading-margin ml-0">
            <HeadingText text={"Paiya"} isMainHeading={true} />
          </div>
        </Col>
      </Row>
      <Row className="form-container">
        <Col xs="12">
          <Form>
            <div className="">{renderForm()}</div>
          </Form>
        </Col>
      </Row>

      <PaiyaError
        giftCsvError={props.giftCsvError}
        movStatusError={props.movStatusError}
        storeCsvError={props.storeCsvError}
        showModal={showStatusModal}
        closeModal={closeStatusModal}
      />

    </Container>
  );
};

PaiyaPage.defaultProps = {
  dummyValidation: false,
};

export default PaiyaPage;
